import { useEffect } from 'react';
import { Link, Outlet, useNavigate } from 'react-router';
import { ActionMenu, Avatar, Icon, IconButton, useAuth, useTheme } from '@saas/ui';

/**
 * マニュアル専用シェル。業務コンソールのヘッダーとメニューを外し、
 * Docmostへブラウザー全体を割り当てる。
 */
export function ManualShell() {
  const { me, logout } = useAuth();
  const { resolved, toggle } = useTheme();
  const navigate = useNavigate();

  useEffect(() => {
    const previous = document.title;
    document.title = `マニュアル | ${me?.tenant.name ?? 'ooak'}`;
    return () => {
      document.title = previous;
    };
  }, [me?.tenant.name]);

  return (
    <div className="flex h-dvh min-h-0 flex-col overflow-hidden bg-base">
      <a href="#manual-main" className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-50 focus:rounded-input focus:bg-card focus:px-4 focus:py-2">
        マニュアル本文へ移動
      </a>
      <header className="z-40 flex h-12 shrink-0 items-center gap-1 border-b border-line bg-card px-2 md:h-10 md:px-3">
        <Link to="/manual" className="flex min-w-0 items-center gap-1.5 rounded-input px-1.5 py-0.5 hover:bg-sunken">
          <span className="font-serif text-lg font-semibold leading-6">ooak</span>
          <span className="text-caption text-fg-secondary">manual</span>
        </Link>
        <span className="hidden h-4 w-px bg-line sm:block" aria-hidden="true" />
        <span className="hidden max-w-48 truncate text-caption font-medium sm:block">{me?.tenant.name}</span>
        <div className="flex-1" />
        <a href="/" className="hidden min-tap items-center gap-1.5 rounded-input px-2 text-caption text-fg-secondary hover:bg-sunken hover:text-fg sm:flex md:!min-h-8">
          <Icon name="open_in_new" size={20} />
          業務コンソール
        </a>
        <IconButton
          icon={resolved === 'dark' ? 'light_mode' : 'dark_mode'}
          label={resolved === 'dark' ? 'ライトモードに切り替え' : 'ダークモードに切り替え'}
          size={20}
          className="md:!min-h-8 md:!min-w-8"
          onClick={toggle}
        />
        <ActionMenu
          className="md:[&>button]:!min-h-8 md:[&>button]:!px-1.5"
          label={<Avatar name={me?.user.displayName} size={24} />}
          items={[
            { label: '業務コンソール', icon: 'open_in_new', onSelect: () => navigate('/') },
            { label: 'プロフィール・パスワード', icon: 'person', onSelect: () => navigate('/settings/profile') },
            { label: 'ログアウト', icon: 'logout', onSelect: () => void logout() },
          ]}
        />
      </header>
      <main id="manual-main" tabIndex={-1} className="flex min-h-0 flex-1 outline-none">
        <Outlet />
      </main>
    </div>
  );
}
